<template>
    <multiselect
        v-model="status"
        :options="statusOptions"
        track-by="key"
        label="value"
        :multiple="false"
        :allowEmpty="false"
        placeholder="Estado"
        selectedLabel=""
        selectLabel=""
        deselectLabel=""
        @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {statusOptions} from '@/constants/consignment-constants';

    export default {
        name: "ConsignmentStatusSelector",
        components: {
            Multiselect
        },
        props: {
            value: String
        },
        data: function () {
            return {
                status: !!this.value ? this.findStatusByKey(this.value) : null
            }
        },
        computed: {
            statusOptions() {
                return statusOptions;
            }
        },
        methods: {
            findStatusByKey(key) {
                return statusOptions.find(status => (status.key === key));
            },
            notifyChange(status) {
                this.$emit('input', status.key);
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.status = this.findStatusByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>